var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thumbnail"},[_c('v-img',_vm._g(_vm._b({},'v-img',_vm.props,false),_vm.$listeners),[_c('v-row',{staticClass:"fill-height ma-0",attrs:{"slot":"placeholder","align":"center","justify":"center"},slot:"placeholder"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.props.progressColor || 'white'}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }